import { BasePlugin } from '../base'
import mdcTextField from './mdc-textfield.vue'

export { mdcTextField }

export default BasePlugin({
  mdcTextField
})
